import { cn } from "../../libs/cn";

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Загрузка"
      className={cn(
        "inline-block size-6 animate-spin rounded-full border-[3px] border-current border-r-transparent",
        className,
      )}
    />
  );
}
